export const CLIENT_LOGIN_URL = 'https://www.portal.versalaunch.com';

/* Nav is organized around the six solution pillars, not individual services.
   Service detail pages still exist and are linked from their pillar page. */
export const solutionsMenuColumns = [
  {
    title: 'Build',
    links: [
      { label: 'Website & Commerce', to: '/solutions/websites-commerce' },
      { label: 'Business Software', to: '/solutions/business-software' }
    ]
  },
  {
    title: 'Answer',
    links: [
      { label: 'Communications', to: '/solutions/communications' },
      { label: 'AI Reception', to: '/solutions/ai-reception' }
    ]
  },
  {
    title: 'Grow & Maintain',
    links: [
      { label: 'Search & Growth', to: '/solutions/search-growth' },
      { label: 'IT & Support', to: '/solutions/support' }
    ]
  },
  {
    title: 'Explore',
    links: [
      { label: 'All Solutions', to: '/solutions' },
      { label: 'Pricing', to: '/plans' },
      { label: 'Client Login', href: CLIENT_LOGIN_URL, external: true }
    ]
  }
];

export const industriesMenuColumns = [
  {
    title: 'By business type',
    links: [
      { label: 'Home Services & Contractors', to: '/industries/contractors' },
      { label: 'Restaurants', to: '/industries/restaurants' },
      { label: 'Retail & Online Stores', to: '/industries/online-stores' },
      { label: 'Professional Services', to: '/industries/professional-services' }
    ]
  },
  {
    title: 'More industries',
    links: [
      { label: 'Salons & Spas', to: '/industries/salons-spas' },
      { label: 'Gyms & Studios', to: '/industries/gyms-studios' },
      { label: 'Multi-Location Businesses', to: '/industries/multi-location' },
      { label: 'All Industries', to: '/industries' }
    ]
  }
];

export const resourcesMenuColumns = [
  {
    title: 'Start Here',
    links: [
      { label: 'All Resources', to: '/resources' },
      { label: 'Getting Started Guide', to: '/resources/getting-started' },
      { label: 'Best Practices Playbook', to: '/resources/best-practices' }
    ]
  },
  {
    title: 'Growth Library',
    links: [
      { label: 'Marketing Strategies', to: '/resources/marketing-strategies' },
      { label: 'SEO for Your Business', to: '/resources/seo-guide' },
      { label: 'Growth Tips', to: '/resources/growth-tips' },
      { label: 'Blog', to: '/blog' }
    ]
  },
  {
    title: 'Company',
    links: [
      { label: 'Projects', to: '/portfolio' },
      { label: 'Case Studies', to: '/resources/case-studies' },
      { label: 'Careers', to: '/careers' },
      { label: 'Book a Call', to: '/book' }
    ]
  }
];

export const resourcesFeatured = {
  imageSrc: '/images/Overlookiung-PC.jpg',
  imageAlt: 'Versa Launch resources',
  kicker: 'Versa Launch Resources',
  description: 'Clean, practical guides to get more leads, appointments, and repeat customers.',
  ctaLabel: 'Explore Resource Hub ->',
  ctaTo: '/resources'
};
